// extracted by mini-css-extract-plugin
export default {"container":"InvalidPharmacyWarningMessage_container__Y6HCN"};